import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useParams } from 'react-router-dom'

import { createSection } from 'panel/partner/product-config/redux/actions/section'

const initialState = { isActive: true, section: 0, name: '', min: 0, max: 0, order: 0 }

const SectionForm: React.FC = () => {
  const [form, setForm] = useState(initialState)

  const { partnerId, id: pProdId } = useParams<{ [x: string]: string }>()

  const dispatch = useDispatch()

  function handleSubmit (e: React.FormEvent): void {
    e.preventDefault()
    if (partnerId && pProdId) {
      createSection(partnerId, pProdId, form)(dispatch).then(res => {
        if (res?.status === 'success') {
          setForm(initialState)
        }
      })
    }
  }

  const gridTemplateColumns = '1fr 100px 100px 100px 100px 150px'

  return (
    <form className="row justify-start" onSubmit={handleSubmit}>
      <h2>Nova Sessão</h2>

      <div className="row align-end" style={{ display: 'grid', gridTemplateColumns }}>
        <div className="form-control">
          <label>Nome</label>
          <input
            type="text"
            value={form.name}
            onChange={(e): void => setForm({ ...form, name: e.target.value })}
            required
          />
        </div>
        <div className="form-control">
          <label>Mínimo</label>
          <input
            type="number"
            value={form.min}
            step={1}
            onChange={(e): void => setForm({ ...form, min: parseInt(e.target.value) })}
            required
          />
        </div>
        <div className="form-control">
          <label>Máximo</label>
          <input
            type="number"
            value={form.max}
            step={1}
            onChange={(e): void => setForm({ ...form, max: parseInt(e.target.value) })}
            required
          />
        </div>
        <div className="form-control">
          <label>Ordem</label>
          <input
            type="number"
            value={form.order}
            step={1}
            onChange={(e): void => setForm({ ...form, order: parseInt(e.target.value) })}
            required
          />
        </div>
        <div className="form-control">
          <label>Ativo?</label>
          <select
            value={form.isActive ? 1 : 0}
            onChange={(e): void => setForm({ ...form, isActive: parseInt(e.target.value) === 1 })}
            required
          >
            <option value={1}>Sim</option>
            <option value={0}>Não</option>
          </select>
        </div>
        <button className="primary"><i className="fa fa-plus"></i> Adicionar</button>
      </div>

    </form>
  )
}

export default SectionForm
